import $i18n from '@alife/panda-i18n';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import debounce from 'lodash/debounce';
import { CnAsyncSelect } from '@alife/cn-ui';
import { getOwners, getItemCenterHost } from './utils';
function OwnerSelect(props) {
    const { params = { lastActiveOptions: [] }, mode, value } = props;
    const [dataSource, setDataSource] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [lastFilterText, setLastFilterText] = useState('');
    const valueRef = useRef();
    const setFilterTextDebounced = useCallback(debounce((v = '') => {
        setFilterText(v);
    }, 500), []);
    const handleSearch = useCallback((v) => {
        if (v) {
            setLastFilterText(v);
        }
        const tmpKeyWord = typeof v === 'string' ? v : '';
        const tmpCustomParams = Object.keys(params)
            .reduce((result, key) => {
            if (key === 'lastActiveOptions' && valueRef.current) {
                if (Array.isArray(value)) {
                    result.push(`${key}=${JSON.stringify(valueRef.current)}`);
                }
                else {
                    result.push(`${key}=${JSON.stringify([valueRef.current])}`);
                }
            }
            else {
                result.push(`${key}=${params[key]}`);
            }
            return result;
        }, [])
            .join('&');
        const customParams = tmpCustomParams ? `&${tmpCustomParams}` : '';
        const hostName = getItemCenterHost(window.location);
        return getOwners(hostName, tmpKeyWord, customParams).then((res) => {
            const { data } = res;
            const { result = [], lastActiveOptions = [] } = data;
            setDataSource([...result, ...lastActiveOptions]);
        });
    }, [params, value]);
    useEffect(() => {
        valueRef.current = value;
    }, [value]);
    useEffect(() => {
        if (lastFilterText !== filterText) {
            handleSearch(filterText);
        }
    }, [filterText, lastFilterText, handleSearch, value]);
    // 初始化执行一次
    useEffect(() => {
        handleSearch();
    }, [value]);
    return (React.createElement(CnAsyncSelect, { placeholder: $i18n.get({ id: 'PleaseSelectTheOwner', dm: '请选择货主' }), ...props, mode: mode || 'single', showSearch: true, hasClear: true, filterLocal: false, autoWidth: false, onSearch: (v) => {
            setFilterTextDebounced(v);
        }, dataSource: dataSource }));
}
OwnerSelect.displayName = 'OwnerSelect';
export { OwnerSelect };
